/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'quote': {
    width: 12,
    height: 12,
    viewBox: '0 0 12 12',
    data: '<g transform="translate(0 1)" _stroke="#376F99" _fill="none" fill-rule="evenodd"><circle pid="0" cx="8.547" cy="2.217" r="2.115"/><path pid="1" d="M9.017 5.432v3.365c0 .645-.562 1.2-1.207 1.2H1.918c-.646 0-1.161-.555-1.161-1.2V2.904c0-.645.515-1.168 1.16-1.168h3.405"/></g>'
  }
})
